import { StatusBadge } from '../../components/core';
import { type Column } from '../../components/feedback';
import { ReportList } from './ReportList';

interface SubRow {
  id: string;
  tenantId: string;
  tenantName: string;
  status: string;
  planName: string | null;
  billingCycle: string | null;
  startAt: string | null;
  endAt: string | null;
  nextBillingAt: string | null;
}

const day = (iso: string | null) =>
  iso ? new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

const columns: Column<SubRow>[] = [
  { key: 'tenant', header: 'Tenant', render: (r) => <span className="font-medium">{r.tenantName}</span> },
  { key: 'plan', header: 'Plan', render: (r) => <span>{r.planName ?? '—'}</span> },
  { key: 'cycle', header: 'Cycle', render: (r) => <span className="text-muted text-sm">{r.billingCycle?.toLowerCase() ?? '—'}</span> },
  { key: 'status', header: 'Status', render: (r) => <StatusBadge status={r.status} /> },
  { key: 'start', header: 'Started', render: (r) => <span className="text-muted text-sm">{day(r.startAt)}</span> },
  { key: 'end', header: 'Ends', render: (r) => <span className="text-muted text-sm">{day(r.endAt)}</span> },
  { key: 'next', header: 'Next billing', render: (r) => <span className="text-muted text-sm">{day(r.nextBillingAt)}</span> },
];

export function AdminSubscriptionsPage() {
  return (
    <ReportList<SubRow>
      title="Subscriptions"
      subtitle="Every plan held by every tenant, and when it renews"
      endpoint="/api/admin/subscriptions"
      searchPlaceholder="Search tenants…"
      columns={columns}
      emptyText="No subscriptions yet."
      csv={{
        filename: 'subscriptions.csv',
        header: ['Tenant', 'Plan', 'Cycle', 'Status', 'Started', 'Ends', 'Next billing'],
        toRow: (r) => [r.tenantName, r.planName, r.billingCycle, r.status, r.startAt, r.endAt, r.nextBillingAt],
      }}
    />
  );
}